import React from 'react';
import NavBar from "../../layout/NavBar";
import {Redirect, Route, Switch, useRouteMatch} from "react-router-dom";
import {Box} from "@chakra-ui/layout";
import AdminLogin from "./AdminLogin";
import AdminCenter from "./AdminCenter";
import NotFound from "../../error/404";
import AdminPrivateRoute from "../../../utilities/AdminPrivateRoute";

function Admin() {
  let {path, url} = useRouteMatch();
  console.log(path, url);

  return (
    <Box>
      <NavBar role={"admin"}/>
      <Switch>
        <AdminPrivateRoute exact path={`${path}`} component={AdminCenter} />
        <Route path={`${path}/login`} component={AdminLogin}/>
        <Route path="*" component={NotFound}/>
      </Switch>
    </Box>
  );
}

export default Admin;